/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect } from "react";
import { popupcontext } from "../../../../../context/Popupscontext";
import Button from "../../../../Helpers/Button/Button";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import { useMap } from "react-leaflet";
import trans from "../../../../../utils";

export default function ObjectUsersFooter() {
	const { handleClose } = useContext(popupcontext);
	const map = useMap();
	const {
		setChecked,
		setFilter,
		setSearchQuery,
		childCheck,
		setChildCheck,
		parentCheck,
		setParentCheck,
		setIsFilterTriggered,
	} = useContext(filtrationcontext);

	const handleReset = () => {
		setFilter(false);
		setIsFilterTriggered(false);
		localStorage.removeItem("UserFiltration");
		setChecked([]);
		setChildCheck([]);
		setParentCheck([]);
		setSearchQuery("");
		map.dragging.enable();
	};

	const handleShow = () => {
		setFilter(true);
		setIsFilterTriggered(true);
		handleClose("objectUsers");
		setSearchQuery("");
		map.dragging.enable();
		setChecked([]);
	};

	useEffect(() => {
		const wasReloaded = localStorage.getItem("pageReloaded");
		if (wasReloaded) {
			localStorage.removeItem("pageReloaded");
			setChecked([]);
		} else {
			localStorage.setItem("pageReloaded", "true");
		}
	}, [setChecked, setFilter]);

	return (
		<div className="px-3 pb-3 flex-between">
			<div className="filter-selection">
				{childCheck.length + parentCheck.length} {trans("Selected")}
			</div>
			<div className="flex-between gap-8">
				<Button
					type="default"
					htmlType="button"
					text={trans("Reset")}
					onClick={handleReset}
				/>
				<Button
					type="primary"
					htmlType="button"
					text={trans("Show Vehicles")}
					onClick={handleShow}
					disabled={parentCheck?.length === 0 && childCheck?.length === 0}
				/>
			</div>
		</div>
	);
}
